import AuthAxios from '@/lib/api/axios/AuthAxios'

interface WorkspaceInviteLinkResponse {
  inviteUrl: string
  inviteCode: string
}

/**
 * Gets the shareable invite link for a workspace.
 * Auto-generates an invite code if one doesn't exist yet.
 */
export async function getInviteLink(
  workspaceSlug: string,
): Promise<WorkspaceInviteLinkResponse> {
  const response = await AuthAxios.get<WorkspaceInviteLinkResponse>(
    `/api/v1.0/e/${workspaceSlug}/invites/link`,
  )
  return response.data
}
